import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { LicenseManager } from 'ag-grid-enterprise';
import { EnvironmentLoader } from 'environments/utils/environment-loader.util';
import { AppModule } from './app/app.module';

// LicenseManager.setLicenseKey('ag-Grid_Evaluation_License_Key_Not_for_Production_1Devs13_December_2017__MTUxMzEyMzIwMDAwMA==d23971dbdbb4d82d11b1367e66a22ddf');
// LicenseManager.setLicenseKey('United_Nations__MultiApp_4Devs4_March_2020__MTU4MzI4MDAwMDAwMA==0a4e7753f06af598872417a31084c1ca');
// LicenseManager.setLicenseKey('CompanyName=United Nations,LicensedGroup=Multi,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=4,LicensedProductionInstancesCount=4,AssetReference=AG-010623,ExpiryDate=21_September_2021_[v2]_MTYzMjE3ODgwMDAwMA==af71b9317395032c3eecc11bc949ba09');
// LicenseManager.setLicenseKey('CompanyName=United Nations,LicensedGroup=UN-DGACM-BAS,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=8,LicensedProductionInstancesCount=4,AssetReference=AG-024180,ExpiryDate=11_January_2023_[v2]_MTY3MzM5NTIwMDAwMA==ab0b4a6f21641dc3d3bdc6b89adf3daa');
// LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-075736}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{United_Nations}_is_granted_a_{Multiple_Applications}_Developer_License_for_{8}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{4}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{20_May_2026}____[v3]_[01]_MTc3OTIzMTYwMDAwMA==7dff4eca2be7981029a8a46099ee8dd3');
LicenseManager.setLicenseKey(`Using_this_{AG_Grid}_Enterprise_key_{AG-117398}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{United_Nations}_is_granted_a_{Multiple_Applications}_Developer_License_for_{8}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{4}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{20_May_2027}____[v3]_[01]_MTgxMDc2NzYwMDAwMA==8c3bdb0c84fb1562c77d49fca51bcd94`);


EnvironmentLoader.loadEnvironment().then(() => {
    const branch = EnvironmentLoader.environment.branch;
  
    switch (branch) {
      case 'DEV':
        document.title = 'iGAEAD+ DEV';
        break;
      case 'QAT':
        document.title = 'iGAEAD+ QAT';
        break;
      case 'UAT':
        document.title = 'iGAEAD+ UAT';
        break;
      case 'PROD':
      default:
        document.title = 'iGAEAD+';
        break;
    }
  
    if (EnvironmentLoader.environment.production) {
      enableProdMode();
    }
  
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  });

  
